import { render, staticRenderFns } from "./NewsPreview.vue?vue&type=template&id=8b53a750"
import script from "./NewsPreview.vue?vue&type=script&lang=ts"
export * from "./NewsPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports